
// REACT & REDUX
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import createBrowserHistory from "history/createBrowserHistory";
import registerServiceWorker from './registerServiceWorker';

// STYLE, PROPS & TRANSLATIONS
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

// COMMON
import { store } from './store';

// COMPONENTS
import App from './App';

// CONTAINERS

// ACTIONS & API

// *************************************************************************************************************************************

export const history = createBrowserHistory();

ReactDOM.render(
    <Provider store={store}>
        <BrowserRouter history={history}>
            <I18nextProvider i18n={i18n}>
                <App />
            </I18nextProvider>
        </BrowserRouter>
    </Provider>,
    document.getElementById("root"));
registerServiceWorker();